(function () {
    angular.module('tradersyard').component('tyNavigationSidebar', {
        template: `
            <ty-base-navigation-sidebar
                offices-label="Offices"
            />
        `,
    });
})();
